import React, { FC } from 'react';

import { EmptyGame as EmptyGameBase, EmptyGameProps as BaseEmptyGameProps } from 'app/design-system/components/EmptyGame';
import { useTranslation } from 'app/lang';

import dictionary from './EmptyGame.dictionary.json';

// ---

type EmptyGameProps = {
  text?: BaseEmptyGameProps['text'];
  typeText?: 'noFilteredEvents' | 'noEvents';
} & Omit<BaseEmptyGameProps, 'text'>;

const EmptyGame: FC<EmptyGameProps> = ({
  typeText = 'noEvents',
  ...props
}) => {
  const { t } = useTranslation();
  const emptyGameText = props.text || t(dictionary[typeText]);

  return (
    <EmptyGameBase {...props}
                   text={emptyGameText} />
  );
};

export default EmptyGame;
